import api from 'src/config/api';
import {
	ICreateStudyRequest,
	IGetStudiesRequestParams,
	IInferenceResult,
	IStudyBase,
	IStudyDetails,
	IStudyWithImages,
	IUpdateStudyRequest,
} from 'src/features/study/domain/types';
import { IStudyWithAssignment } from 'src/features/study_assignment/domain/types';

export const studyApi = {
	getStudyDetails: async (
		studyId: number,
		siteSlug: string,
	): Promise<IStudyDetails> => {
		const response = await api.get(`/api/v1/study/${studyId}`, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},

	createStudy: async (
		requestBody: ICreateStudyRequest,
		siteSlug: string,
	): Promise<IStudyDetails> => {
		const response = await api.post(`/api/v1/study`, requestBody, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},

	getStudies: async (
		requestParams: IGetStudiesRequestParams,
		siteSlug: string,
	): Promise<IPaginatedResponse<IStudyWithAssignment>> => {
		const {
			page = 1,
			sort,
			order,
			start_date,
			end_date,
			assigned_to_me,
		} = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(assigned_to_me && { assigned_to_me: String(assigned_to_me) }),
			...(sort && order && { sort, order }),
			...(start_date && end_date && { start_date, end_date }),
		});

		const response = await api.get(`/api/v1/studies?${params}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	updateStudy: async (
		studyId: number,
		requestBody: IUpdateStudyRequest,
		siteSlug: string,
	): Promise<IStudyBase> => {
		const response = await api.patch(
			`/api/v1/study/${studyId}`,
			requestBody,
			{
				headers: { Site: siteSlug },
			},
		);
		return response.data;
	},

	getStudyWithImages: async (
		studyId: number,
		siteSlug: string,
	): Promise<IStudyWithImages> => {
		const response = await api.get(`/api/v1/study/${studyId}/images`, {
			headers: { Site: siteSlug },
		});

		return response.data;
	},

	runInference: async (
		studyId: number,
		siteSlug: string,
	): Promise<IInferenceResult[]> => {
		const response = await api.get(
			`/api/v1/study/${studyId}/run-inference`,
			{ headers: { Site: siteSlug } },
		);
		return response.data;
	},

	deleteStudy: async (studyId: number, siteSlug: string): Promise<void> => {
		const response = await api.delete(`/api/v1/study/${studyId}`, {
			headers: { Site: siteSlug },
		});
		return response.data;
	},
};
